import { render } from "./cgList.vue?vue&type=template&id=7d61b89a&scoped=true"
import script from "./cgList.vue?vue&type=script&lang=js"
export * from "./cgList.vue?vue&type=script&lang=js"

import "./cgList.vue?vue&type=style&index=0&id=7d61b89a&scoped=true&lang=less"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d61b89a"]])

export default __exports__